import { createSlice, current } from '@reduxjs/toolkit';
import {
	getResidueIntakeList,
	getResidueIntake,
	addNewResidueIntake,
	updateResidueIntake,
	deleteResidueIntake,
} from './thunk';

export const initialState = {
	residueIntakeList: [],
	residueIntakeDetail: null,
	isLoadingList: false,
	isLoadingDetail: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	error: null,
};

const ResidueIntakeSlice = createSlice({
	name: 'ResidueIntakes',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
		cleanResidueIntakeDetail(state) {
			state.residueIntakeDetail = null;
		},
		restartResidueIntake(state) {
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDeleteError = false;
			state.error = null;
		},
	},
	extraReducers: builder => {
		builder
			.addCase(getResidueIntakeList.pending, state => {
				state.isLoadingList = true;
				state.error = null;
			})
			.addCase(getResidueIntakeList.fulfilled, (state, action) => {
				state.residueIntakeList = action.payload || [];
				state.isLoadingList = false;
			})
			.addCase(getResidueIntakeList.rejected, (state, action) => {
				state.isLoadingList = false;
				state.error = action.error?.message || 'Error al cargar ingresos.';
			});

		builder
			.addCase(getResidueIntake.pending, state => {
				state.isLoadingDetail = true;
				state.error = null;
			})
			.addCase(getResidueIntake.fulfilled, (state, action) => {
				state.residueIntakeDetail = action.payload;
				state.isLoadingDetail = false;
			})
			.addCase(getResidueIntake.rejected, (state, action) => {
				state.isLoadingDetail = false;
				state.error = action.error?.message || 'Error al cargar ingreso.';
			});

		builder
			.addCase(addNewResidueIntake.pending, state => {
				state.isAdding = true;
				state.isAdded = false;
				state.isAddError = false;
			})
			.addCase(addNewResidueIntake.fulfilled, (state, action) => {
				state.residueIntakeList.push(action.payload);
				state.isAdding = false;
				state.isAdded = true;
				state.requireCloseModal = true;
			})
			.addCase(addNewResidueIntake.rejected, (state, action) => {
				state.isAdding = false;
				state.isAdded = false;
				state.isAddError = true;
				state.error = action.payload || action.error?.message || null;
			});

		builder
			.addCase(updateResidueIntake.pending, state => {
				state.isUpdating = true;
				state.isUpdated = false;
				state.isUpdateError = false;
			})
			.addCase(updateResidueIntake.fulfilled, (state, action) => {
				const updated = action.payload || {};
				state.residueIntakeList = state.residueIntakeList.map(item =>
					item._id?.toString() === updated._id?.toString()
						? { ...item, ...updated }
						: item
				);
				state.isUpdating = false;
				state.isUpdated = true;
				state.requireCloseModal = true;
			})
			.addCase(updateResidueIntake.rejected, (state, action) => {
				state.isUpdating = false;
				state.isUpdated = false;
				state.isUpdateError = true;
				state.error = action.payload || action.error?.message || null;
			});

		builder
			.addCase(deleteResidueIntake.pending, state => {
				state.isDeleting = true;
				state.isDeleted = false;
				state.isDeleteError = false;
			})
			.addCase(deleteResidueIntake.fulfilled, (state, action) => {
				state.residueIntakeList = current(state.residueIntakeList).filter(
					item => item._id !== action.payload._id
				);
				state.isDeleting = false;
				state.isDeleted = true;
				state.requireCloseModal = true;
			})
			.addCase(deleteResidueIntake.rejected, (state, action) => {
				state.isDeleting = false;
				state.isDeleted = false;
				state.isDeleteError = true;
				state.error = action.payload || action.error?.message || null;
			});
	},
});

export const {
	setRequireCloseModal,
	cleanResidueIntakeDetail,
	restartResidueIntake,
} = ResidueIntakeSlice.actions;

export default ResidueIntakeSlice.reducer;
